import request from "@utils/request";
import { set } from "mobx";
import Const from "@const";
// import apiUrl from "@const/apiUrl";

export default class baseState {

  constructor() {
    Object.getOwnPropertyNames(this.__proto__).forEach(k => {
      const item = this[k];
      if (typeof item === 'function') {
        const funStr = item.toString() || "";
        funStr.split(",").forEach(kv => {
          if (kv.split(":")[0].trim() === "loading") {
            let loadingKey = kv.split(":")[1].trim().replace(/"/g, "");
            if (loadingKey) {
              loadingKey += "Loading";
              if (!this.hasOwnProperty(loadingKey)) {
                const obj = {};
                obj[loadingKey] = false;
                set(this, obj);
              }
            }
          }
        });
      }
    });
  }

  fetch(data, success, fail) {
    const { setState, cache, loading = "" } = data;
    const loadingKey = (loading || "") + "Loading";
    if (loading) {
      // 自动管理loading，如果正在请求将返回
      if (this[loadingKey]) {
        return;
      }
      this[loadingKey] = true;
    }
    // console.log(this[loadingKey]);
    return request({
      baseURL: data.baseURL || Const.BASE_API,
      url: data.url,
      method: data.method || 'post',
      data: data.data || {},
      params: data.params,
    }, res => {
      if (typeof cache !== "undefined") {
        const mergeKey = "merge_" + (cache || data.url);
        if (res && this[mergeKey] && res.currentPage !== 1) {
          res.result = this[mergeKey].result.concat(res.result);
        }
        this[mergeKey] = res;
      }
      if (setState) {
        if (typeof setState === "function") {
          setState.call(this, res);
        } else if (typeof this[setState] === "function") {
          this[setState](res);
        }
      }
      if (loading) {
        this[loadingKey] = false;
      }
      success && success(res);
    }, err => {
      if (loading) {
        this[loadingKey] = false;
      }
      fail && fail(err);
    });
  }

  getFetch(config, success, fail) {
    config.method = 'get';
    return this.fetch(config, success, fail);
  }

  postFetch(config, success, fail) {
    const { data } = config;
    config.method = 'post';

    config.params = {};
    const { size, current } = data;
    if (size) config.params.size = size;
    if (current) config.params.current = current;

    return this.fetch(config, success, fail);
  }
}

export function exportUtil({ data, url = '' }) {
  let search = '';
  Object.keys(data).map(key => {
    if (key !== 'current' && key !== 'size') search += `${key}=${data[key]}&`;
  });
  window.location.href = Const.BASE_API + '/' + url + '?' + search.slice(0, -1);
  return Promise.resolve(0);
}
